import { ModuleWithProviders, NgModule } from '@angular/core';

import { RtUIAttributesModule } from './attributes/attributes.module';
import { RtUIColorPickerModule } from './color-picker/color-picker.module';
import { RtUICommonModule } from './common/common.module';
import { RtUICoreModule } from './core/core.module';
import { RtUIDataTableModule } from './data-table/data-table.module';
import { RtUIDialogModule } from './dialog/dialog.module';
import { RtUIDialogsModule } from './dialogs/dialogs.module';
import { RtUIFormsModule } from './forms/forms.module';
import { IconsContainerModule } from './icons-container/icons-container.module';
import { RtUIIntersectionObserverModule } from './intersection-observer/intersection-observer.module';
import { RtUIListsModule } from './lists/lists.module';
import { RtUINotificationsModule } from './notifications/notifications.module';
import { RtUIOptions } from './options';
import { PDF_VIEWER_CONFIG_TOKEN } from './pdf-viewer/pdf-viewer.di';
import { RtUIPdfViewerModule } from './pdf-viewer/pdf-viewer.module';
import { PdfViewerConfig } from './pdf-viewer/pdf-viewer.types';
import { RtUITourHighlightModule } from './tour-highlight/tour-highlight.module';

const RT_UI_MODULES = [
  RtUIAttributesModule,
  RtUICoreModule,
  RtUICommonModule,
  RtUIColorPickerModule,
  RtUIDataTableModule,
  RtUIDialogModule,
  RtUIDialogsModule,
  RtUIFormsModule,
  RtUIListsModule,
  RtUINotificationsModule,
  RtUITourHighlightModule,
  RtUIIntersectionObserverModule,
  RtUIPdfViewerModule,
];

@NgModule({
  imports: [...RT_UI_MODULES],
  exports: [RT_UI_MODULES, IconsContainerModule],
  declarations: [],
})
export class RtUIModule {
  public static forRoot(
    options?: RtUIOptions,
    pdfViewerConfig?: PdfViewerConfig,
  ): ModuleWithProviders<RtUIModule> {
    return {
      ngModule: RtUIModule,
      providers: [
        {
          provide: RtUIOptions,
          useValue: options,
        },
        {
          provide: PDF_VIEWER_CONFIG_TOKEN,
          useValue: pdfViewerConfig,
        },
        ...(RtUICoreModule.forRoot().providers || []),
        ...(RtUICommonModule.forRoot().providers || []),
        ...(RtUIColorPickerModule.forRoot().providers || []),
        ...(RtUIDialogModule.forRoot().providers || []),
        ...(RtUIDialogsModule.forRoot().providers || []),
        ...(RtUIFormsModule.forRoot().providers || []),
        ...(RtUINotificationsModule.forRoot().providers || []),
        ...(RtUITourHighlightModule.forRoot().providers || []),
      ],
    };
  }
}
